import { CanActivate, Router, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { LoginService } from '../login/login.service';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

/**
 * Ensures the authenticated user holds at least one Soundradar role
 * (inspector_viewer, inspector_clerk, inspector_admin).
 *
 * Waits for MSAL to finish its interaction (InteractionStatus.None) before
 * checking, to avoid a false redirect on initial page load.
 *
 * Users who are authenticated via MSAL but have no role assigned in the
 * Entra App Registration are redirected to /unauthorized.
 */
@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  constructor(
    private readonly loginService: LoginService,
    private readonly msalBroadcastService: MsalBroadcastService,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.msalBroadcastService.inProgress$.pipe(
      filter((status) => status === InteractionStatus.None),
      take(1),
      map(() => {
        if (this.loginService.isAuthorized()) {
          return true;
        }
        return this.router.createUrlTree(['/unauthorized']);
      }),
    );
  }
}
